<template>
  <el-dialog
    title="选择商品"
    :visible.sync="dialogVisible"
    width="70%"
    :before-close="handleClose">
    
    <!-- 这里放置商品选择组件的内容 -->
    <div class="product-select-container">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="product-category">
            <!-- 商品分类树 -->
            <el-tree
              :data="categoryData"
              :props="defaultProps"
              @node-click="handleNodeClick">
            </el-tree>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="product-list">
            <!-- 商品列表 -->
            <el-table
              :data="productList"
              border
              style="width: 100%"
              @selection-change="handleSelectionChange">
              <el-table-column
                type="selection"
                width="55">
              </el-table-column>
              <el-table-column
                prop="productId"
                label="商品编号">
              </el-table-column>
              <el-table-column
                prop="prodName"
                label="商品名称">
              </el-table-column>
              <el-table-column
                prop="defaultSpecValue.specName"
                label="规格">
              </el-table-column>
              <el-table-column
                prop="defaultSpecValue.stock"
                label="库存">
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="confirmSelection">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'ChooseProductAndSpec',
  data() {
    return {
      dialogVisible: false,
      categoryData: [],
      productList: [],
      selectedProducts: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      // 这里可以加载商品分类和商品列表数据
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          console.log(_)
          done()
        })
        .catch(_ => {
          console.log(_)
        })
    },
    handleNodeClick(data) {
      // 处理分类节点点击事件，加载对应分类的商品
      console.log(data)
    },
    handleSelectionChange(val) {
      this.selectedProducts = val
    },
    confirmSelection() {
      if (this.selectedProducts.length === 0) {
        this.$message.warning('请至少选择一件商品')
        return
      }
      
      // 触发父组件事件
      this.$emit('chooseProductAndSpec', this.selectedProducts)
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.product-select-container {
  padding: 10px;
}
.product-category {
  border: 1px solid #ebeef5;
  padding: 10px;
  height: 500px;
  overflow-y: auto;
}
.product-list {
  height: 500px;
  overflow-y: auto;
}
</style>